var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.771,
    height: 16.771,
    viewBox: "0 0 16.771 16.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043F\\u043E\\u0440\\u0442",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1661",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1661",
    d: "M12.578,2.681a1.215,1.215,0,0,0-.358-.864l-.235-.235.389-.389A.7.7,0,0,0,11.386.2L11,.593,10.762.358a1.224,1.224,0,0,0-1.73,0L8.674.717,8.49.533a1.224,1.224,0,0,0-1.73,0L6.353.942a1.222,1.222,0,0,0,0,1.73L7.636,3.954,3.955,7.635,2.671,6.352a1.226,1.226,0,0,0-1.73,0l-.409.41a1.221,1.221,0,0,0,0,1.729l.184.184-.358.358a1.224,1.224,0,0,0,0,1.73L.593,11,.2,11.386a.7.7,0,1,0,.988.987l.389-.389.235.235a1.223,1.223,0,0,0,1.729,0l.358-.358.184.184a1.223,1.223,0,0,0,1.729,0l.409-.409a1.224,1.224,0,0,0,0-1.73L4.943,8.623,8.623,4.943,9.906,6.226a1.225,1.225,0,0,0,1.729,0l.41-.409a1.221,1.221,0,0,0,0-1.729L11.861,3.9l.358-.358a1.211,1.211,0,0,0,.359-.864Z",
    transform: "translate(0)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1662",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1662",
    d: "M15.23,20.282C14.8,19.96,11,17.066,11,14.612a2.623,2.623,0,0,1,4.542-1.778,2.623,2.623,0,0,1,4.542,1.778c0,2.454-3.8,5.348-4.23,5.67a.524.524,0,0,1-.625,0Z",
    transform: "translate(-3.313 -3.614)",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSport);
export default __webpack_public_path__ + "static/media/Sport.04d2768c4f1da46c2bdedfcaf979008b.svg";
export { ForwardRef as ReactComponent };